import { render, staticRenderFns } from "./SaveChangesModal.vue?vue&type=template&id=37b92d94"
import script from "./SaveChangesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveChangesModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports